import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function e(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function n(n) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? e(Object(o), !0).forEach(function (e) {
      r(n, e, o[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : e(Object(o)).forEach(function (e) {
      Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(o, e));
    });
  }

  return n;
}

function t(e) {
  return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function r(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}

function o(e) {
  return function (e) {
    if (Array.isArray(e)) return i(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, n) {
    if (e) {
      if ("string" == typeof e) return i(e, n);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? i(e, n) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function i(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var t = 0, r = new Array(n); t < n; t++) {
    r[t] = e[t];
  }

  return r;
}

function a(e) {
  function n(e, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = n;
  }

  return n.prototype = new Error(), n.prototype.name = e, n.prototype.constructor = n, n;
}

var u = a("LaunchDarklyUnexpectedResponseError"),
    s = a("LaunchDarklyInvalidEnvironmentIdError"),
    c = a("LaunchDarklyInvalidUserError"),
    l = a("LaunchDarklyInvalidEventKeyError"),
    f = a("LaunchDarklyInvalidArgumentError"),
    d = a("LaunchDarklyFlagFetchError"),
    v = a("LaunchDarklyInvalidDataError");

function g(e) {
  return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
}

for (var p = Object.freeze({
  __proto__: null,
  LDUnexpectedResponseError: u,
  LDInvalidEnvironmentIdError: s,
  LDInvalidUserError: c,
  LDInvalidEventKeyError: l,
  LDInvalidArgumentError: f,
  LDFlagFetchError: d,
  LDInvalidDataError: v,
  isHttpErrorRecoverable: g
}), m = [], h = [], y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", w = 0, b = y.length; w < b; ++w) {
  m[w] = y[w], h[y.charCodeAt(w)] = w;
}

function k(e, n, t) {
  for (var r, o, i = [], a = n; a < t; a += 3) {
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(m[(o = r) >> 18 & 63] + m[o >> 12 & 63] + m[o >> 6 & 63] + m[63 & o]);
  }

  return i.join("");
}

h["-".charCodeAt(0)] = 62, h["_".charCodeAt(0)] = 63;
var E = Array.isArray,
    D = Object.keys,
    S = Object.prototype.hasOwnProperty,
    O = ["key", "secondary", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];

function P(e, n) {
  return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (n.startsWith("/") ? "" : "/") + n;
}

function U(e) {
  return function (e) {
    for (var n, t = e.length, r = t % 3, o = [], i = 0, a = t - r; i < a; i += 16383) {
      o.push(k(e, i, i + 16383 > a ? a : i + 16383));
    }

    return 1 === r ? (n = e[t - 1], o.push(m[n >> 2] + m[n << 4 & 63] + "==")) : 2 === r && (n = (e[t - 2] << 8) + e[t - 1], o.push(m[n >> 10] + m[n >> 4 & 63] + m[n << 2 & 63] + "=")), o.join("");
  }(function (e) {
    for (var n = [], t = 0; t < e.length; t++) {
      n.push(e.charCodeAt(t));
    }

    return n;
  }(unescape(encodeURIComponent(e))));
}

function j(e) {
  return U(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

function R(e) {
  return JSON.parse(JSON.stringify(e));
}

function I(e, n) {
  return function e(n, t) {
    if (n === t) return !0;

    if (n && t && "object" == typeof n && "object" == typeof t) {
      var r,
          o,
          i,
          a = E(n),
          u = E(t);

      if (a && u) {
        if ((o = n.length) != t.length) return !1;

        for (r = o; 0 != r--;) {
          if (!e(n[r], t[r])) return !1;
        }

        return !0;
      }

      if (a != u) return !1;
      var s = n instanceof Date,
          c = t instanceof Date;
      if (s != c) return !1;
      if (s && c) return n.getTime() == t.getTime();
      var l = n instanceof RegExp,
          f = t instanceof RegExp;
      if (l != f) return !1;
      if (l && f) return n.toString() == t.toString();
      var d = D(n);
      if ((o = d.length) !== D(t).length) return !1;

      for (r = o; 0 != r--;) {
        if (!S.call(t, d[r])) return !1;
      }

      for (r = o; 0 != r--;) {
        if (!e(n[i = d[r]], t[i])) return !1;
      }

      return !0;
    }

    return n != n && t != t;
  }(e, n);
}

function T(e) {
  setTimeout(e, 0);
}

function L(e, n) {
  var t = e.then(function (e) {
    return n && setTimeout(function () {
      n(null, e);
    }, 0), e;
  }, function (e) {
    if (!n) return Promise.reject(e);
    setTimeout(function () {
      n(e, null);
    }, 0);
  });
  return n ? void 0 : t;
}

function N(e) {
  var n = {};

  for (var t in e) {
    q(e, t) && (n[t] = {
      value: e[t],
      version: 0
    });
  }

  return n;
}

function A(e) {
  var n = {};

  for (var t in e) {
    q(e, t) && (n[t] = e[t].value);
  }

  return n;
}

function x(e, n) {
  for (var t, r = n.slice(0), o = [], i = e; r.length > 0;) {
    for (t = []; i > 0;) {
      var a = r.shift();
      if (!a) break;
      (i -= j(JSON.stringify(a)).length) < 0 && t.length > 0 ? r.unshift(a) : t.push(a);
    }

    i = e, o.push(t);
  }

  return o;
}

function C(e) {
  var n = e.version || "3.6.0";
  return e.userAgent + "/" + n;
}

function F() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
    t[r] = arguments[r];
  }

  return t.reduce(function (e, t) {
    return n(n({}, e), t);
  }, {});
}

function q(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}

function _(e) {
  if (!e) return e;
  var t;

  for (var r in O) {
    var o = O[r],
        i = e[o];
    void 0 !== i && "string" != typeof i && ((t = t || n({}, e))[o] = String(i));
  }

  return t || e;
}

for (var V = Object.freeze({
  __proto__: null,
  appendUrlPath: P,
  btoa: U,
  base64URLEncode: j,
  clone: R,
  deepEquals: I,
  onNextTick: T,
  wrapPromiseCallback: L,
  transformValuesToVersionedValues: N,
  transformVersionedValuesToValues: A,
  chunkUserEventsForUrl: x,
  getLDUserAgentString: C,
  extend: F,
  objectHasOwnProperty: q,
  sanitizeUser: _
}), z = function (e, n) {
  return function (e) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var t = new Uint8Array(16);

      e.exports = function () {
        return n(t), t;
      };
    } else {
      var r = new Array(16);

      e.exports = function () {
        for (var e, n = 0; n < 16; n++) {
          0 == (3 & n) && (e = 4294967296 * Math.random()), r[n] = e >>> ((3 & n) << 3) & 255;
        }

        return r;
      };
    }
  }(n = {
    exports: {}
  }), n.exports;
}(), J = [], M = 0; M < 256; ++M) {
  J[M] = (M + 256).toString(16).substr(1);
}

var $,
    H,
    K = 0,
    B = 0,
    G = function G(e, n, t) {
  var r = n && t || 0,
      o = n || [],
      i = (e = e || {}).node || $,
      a = void 0 !== e.clockseq ? e.clockseq : H;

  if (null == i || null == a) {
    var u = z();
    null == i && (i = $ = [1 | u[0], u[1], u[2], u[3], u[4], u[5]]), null == a && (a = H = 16383 & (u[6] << 8 | u[7]));
  }

  var s = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
      c = void 0 !== e.nsecs ? e.nsecs : B + 1,
      l = s - K + (c - B) / 1e4;
  if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || s > K) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  K = s, B = c, H = a;
  var f = (1e4 * (268435455 & (s += 122192928e5)) + c) % 4294967296;
  o[r++] = f >>> 24 & 255, o[r++] = f >>> 16 & 255, o[r++] = f >>> 8 & 255, o[r++] = 255 & f;
  var d = s / 4294967296 * 1e4 & 268435455;
  o[r++] = d >>> 8 & 255, o[r++] = 255 & d, o[r++] = d >>> 24 & 15 | 16, o[r++] = d >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;

  for (var v = 0; v < 6; ++v) {
    o[r + v] = i[v];
  }

  return n || function (e, n) {
    var t = n || 0,
        r = J;
    return [r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]]].join("");
  }(o);
},
    X = ["debug", "info", "warn", "error", "none"];

function W(e, n) {
  if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");

  function t(e) {
    return function (n) {
      console && console[e] && console[e].call(console, n);
    };
  }

  var r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [t("log"), t("info"), t("warn"), t("error")],
      i = !(!e || !e.destination),
      a = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ",
      u = 1;
  if (e && e.level) for (var s = 0; s < X.length; s++) {
    X[s] === e.level && (u = s);
  }

  function c(e, t, u) {
    if (!(u.length < 1)) {
      var s,
          c = i ? t + ": " + a : a;

      if (1 !== u.length && n) {
        var l = o(u);
        l[0] = c + l[0], s = n.apply(void 0, o(l));
      } else s = c + u[0];

      try {
        r[e](s);
      } catch (e) {
        console && console.log && console.log("[LaunchDarkly] Configured logger's " + t + " method threw an exception: " + e);
      }
    }
  }

  for (var l = {}, f = function f(e) {
    var n = X[e];
    if ("none" !== n) if (e < u) l[n] = function () {};else {
      var t = e;

      l[n] = function () {
        c(t, n, arguments);
      };
    }
  }, d = 0; d < X.length; d++) {
    f(d);
  }

  return l;
}

function Q(e, n) {
  return W({
    level: e,
    prefix: n
  });
}

function Y(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}

var Z = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.",
    ee = function ee(e) {
  return 'Expected application/json content type but got "' + e + '"';
},
    ne = function ne(e) {
  return "local storage is unavailable: " + Y(e);
},
    te = function te(e) {
  return "network error" + (e ? " (" + e + ")" : "");
},
    re = function re(e) {
  return 'Custom event "' + e + '" does not exist';
},
    oe = function oe() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + Z;
},
    ie = function ie() {
  return "No environment/client-side ID was specified." + Z;
},
    ae = function ae(e) {
  return "Error fetching flag settings: " + Y(e);
},
    ue = function ue() {
  return "No user specified." + Z;
},
    se = function se() {
  return "Invalid user specified." + Z;
},
    ce = function ce() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + Z;
},
    le = function le(e, n) {
  return n ? '"' + e + '" is deprecated, please use "' + n + '"' : '"' + e + '" is deprecated';
},
    fe = function fe(e, n, t) {
  return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + n + " - " + (g(e) ? t : "giving up permanently");
},
    de = function de() {
  return "Cannot make HTTP requests in this environment." + Z;
},
    ve = function ve(e) {
  return "Opening stream connection to " + e;
},
    ge = function ge(e, n) {
  return "Error on stream connection: " + Y(e) + ", will continue retrying every " + n + " milliseconds.";
},
    pe = function pe(e) {
  return 'Ignoring unknown config option "' + e + '"';
},
    me = function me(e, n, t) {
  return 'Config option "' + e + '" should be of type ' + n + ", got " + t + ", using default value";
},
    he = function he(e, n) {
  return 'Config option "' + e + '" should be a boolean, got ' + n + ", converting to boolean";
},
    ye = function ye(e, n, t) {
  return 'Config option "' + e + '" was set to ' + n + ", changing to minimum value of " + t;
},
    we = function we(e) {
  return "polling for feature flags at " + e;
},
    be = function be(e) {
  return 'received streaming update for flag "' + e + '"';
},
    ke = function ke(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
},
    Ee = function Ee(e) {
  return 'received streaming deletion for flag "' + e + '"';
},
    De = function De(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
},
    Se = function Se(e) {
  return 'enqueueing "' + e + '" event';
},
    Oe = function Oe(e) {
  return "sending " + e + " events";
},
    Pe = function Pe(e) {
  return 'Config option "'.concat(e, '" must only contain letters, numbers, ., _ or -.');
},
    Ue = Object.freeze({
  __proto__: null,
  clientInitialized: function clientInitialized() {
    return "LaunchDarkly client initialized";
  },
  clientNotReady: function clientNotReady() {
    return "LaunchDarkly client is not ready";
  },
  eventCapacityExceeded: function eventCapacityExceeded() {
    return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
  },
  eventWithoutUser: function eventWithoutUser() {
    return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
  },
  invalidContentType: ee,
  invalidKey: function invalidKey() {
    return "Event key must be a string";
  },
  localStorageUnavailable: ne,
  networkError: te,
  unknownCustomEventKey: re,
  environmentNotFound: oe,
  environmentNotSpecified: ie,
  errorFetchingFlags: ae,
  userNotSpecified: ue,
  invalidUser: se,
  invalidData: function invalidData() {
    return "Invalid data received from LaunchDarkly; connection may have been interrupted";
  },
  bootstrapOldFormat: ce,
  bootstrapInvalid: function bootstrapInvalid() {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  deprecated: le,
  httpErrorMessage: fe,
  httpUnavailable: de,
  identifyDisabled: function identifyDisabled() {
    return "identify() has no effect here; it must be called on the main client instance";
  },
  streamClosing: function streamClosing() {
    return "Closing stream connection";
  },
  streamConnecting: ve,
  streamError: ge,
  unknownOption: pe,
  wrongOptionType: me,
  wrongOptionTypeBoolean: he,
  optionBelowMinimum: ye,
  debugPolling: we,
  debugStreamPing: function debugStreamPing() {
    return "received ping message from stream";
  },
  debugStreamPut: function debugStreamPut() {
    return "received streaming update for all flags";
  },
  debugStreamPatch: be,
  debugStreamPatchIgnored: ke,
  debugStreamDelete: Ee,
  debugStreamDeleteIgnored: De,
  debugEnqueueingEvent: Se,
  debugPostingEvents: Oe,
  debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
    return "sending diagnostic event (" + e.kind + ")";
  },
  invalidTagValue: Pe
}),
    je = {
  baseUrl: {
    default: "https://app.launchdarkly.com"
  },
  streamUrl: {
    default: "https://clientstream.launchdarkly.com"
  },
  eventsUrl: {
    default: "https://events.launchdarkly.com"
  },
  sendEvents: {
    default: !0
  },
  streaming: {
    type: "boolean"
  },
  sendLDHeaders: {
    default: !0
  },
  requestHeaderTransform: {
    type: "function"
  },
  inlineUsersInEvents: {
    default: !1
  },
  allowFrequentDuplicateEvents: {
    default: !1
  },
  sendEventsOnlyForVariation: {
    default: !1
  },
  useReport: {
    default: !1
  },
  evaluationReasons: {
    default: !1
  },
  eventCapacity: {
    default: 100,
    minimum: 1
  },
  flushInterval: {
    default: 2e3,
    minimum: 2e3
  },
  samplingInterval: {
    default: 0,
    minimum: 0
  },
  streamReconnectDelay: {
    default: 1e3,
    minimum: 0
  },
  allAttributesPrivate: {
    default: !1
  },
  privateAttributeNames: {
    default: []
  },
  bootstrap: {
    type: "string|object"
  },
  diagnosticRecordingInterval: {
    default: 9e5,
    minimum: 2e3
  },
  diagnosticOptOut: {
    default: !1
  },
  wrapperName: {
    type: "string"
  },
  wrapperVersion: {
    type: "string"
  },
  stateProvider: {
    type: "object"
  },
  autoAliasingOptOut: {
    default: !1
  },
  application: {
    validator: function validator(e, n, t, r) {
      var o = {};
      return t.id && (o.id = Ie("".concat(e, ".id"), n, t.id, r)), t.version && (o.version = Ie("".concat(e, ".version"), n, t.version, r)), o;
    }
  }
},
    Re = /^(\w|\.|-)+$/;

function Ie(e, n, t, r) {
  if ("string" == typeof t && t.match(Re)) return t;
  r.warn(Pe(e));
}

function Te(e, n, r, o) {
  var i = F({
    logger: {
      default: o
    }
  }, je, r),
      a = {
    all_attributes_private: "allAttributesPrivate",
    private_attribute_names: "privateAttributeNames",
    samplingInterval: null
  };

  function u(e) {
    T(function () {
      n && n.maybeReportError(new f(e));
    });
  }

  var s = F({}, e || {});
  return function (e) {
    var n = e;
    Object.keys(a).forEach(function (e) {
      if (void 0 !== n[e]) {
        var t = a[e];
        o && o.warn(le(e, t)), t && (void 0 === n[t] && (n[t] = n[e]), delete n[e]);
      }
    });
  }(s), function (e) {
    X.forEach(function (n) {
      if ("none" !== n && (!e[n] || "function" != typeof e[n])) throw new Error("Provided logger instance must support logger." + n + "(...) method");
    });
  }((s = function (e) {
    var n = F({}, e),
        r = function r(e) {
      if (null === e) return "any";

      if (void 0 !== e) {
        if (Array.isArray(e)) return "array";
        var n = t(e);
        return "boolean" === n || "string" === n || "number" === n || "function" === n ? n : "object";
      }
    };

    return Object.keys(e).forEach(function (t) {
      var a = e[t];

      if (null != a) {
        var s = i[t];
        if (void 0 === s) u(pe(t));else {
          var c = s.type || r(s.default),
              l = s.validator;

          if (l) {
            var f = l(t, e, e[t], o);
            void 0 !== f ? n[t] = f : delete n[t];
          } else if ("any" !== c) {
            var d = c.split("|"),
                v = r(a);
            d.indexOf(v) < 0 ? "boolean" === c ? (n[t] = !!a, u(he(t, v))) : (u(me(t, c, v)), n[t] = s.default) : "number" === v && void 0 !== s.minimum && a < s.minimum && (u(ye(t, a, s.minimum)), n[t] = s.minimum);
          }
        }
      }
    }), n;
  }(s = function (e) {
    var n = F({}, e);
    return Object.keys(i).forEach(function (e) {
      void 0 !== n[e] && null !== n[e] || (n[e] = i[e] && i[e].default);
    }), n;
  }(s))).logger), s;
}

function Le(e) {
  var n = {};
  return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (n["application-id"] = [e.application.id]), e.application && void 0 !== e.application.version && null !== e.application.id && (n["application-version"] = [e.application.version])), n;
}

function Ne(e, n) {
  if (n && !n.sendLDHeaders) return {};
  var t = {
    "X-LaunchDarkly-User-Agent": C(e)
  };
  n && n.wrapperName && (t["X-LaunchDarkly-Wrapper"] = n.wrapperVersion ? n.wrapperName + "/" + n.wrapperVersion : n.wrapperName);
  var r = Le(n),
      o = Object.keys(r);
  return o.length && (t["x-launchdarkly-tags"] = o.sort().flatMap(function (e) {
    return Array.isArray(r[e]) ? r[e].sort().map(function (n) {
      return "".concat(e, "/").concat(n);
    }) : ["".concat(e, "/").concat(r[e])];
  }).join(" ")), t;
}

function Ae(e, t) {
  return t && t.requestHeaderTransform ? t.requestHeaderTransform(n({}, e)) : e;
}

function xe(e, n, t) {
  var r = "/a/" + n + ".gif",
      o = F({
    "Content-Type": "application/json"
  }, Ne(e, t)),
      i = e.httpFallbackPing,
      a = {
    sendChunk: function sendChunk(n, a, u, s) {
      var c = JSON.stringify(n),
          l = u ? null : G();
      return s ? function n(r) {
        var i = u ? o : F({}, o, {
          "X-LaunchDarkly-Event-Schema": "3",
          "X-LaunchDarkly-Payload-ID": l
        });
        return e.httpRequest("POST", a, Ae(i, t), c).promise.then(function (e) {
          if (e) return e.status >= 400 && g(e.status) && r ? n(!1) : function (e) {
            var n = {
              status: e.status
            },
                t = e.header("date");

            if (t) {
              var r = Date.parse(t);
              r && (n.serverTime = r);
            }

            return n;
          }(e);
        }).catch(function () {
          return r ? n(!1) : Promise.reject();
        });
      }(!0).catch(function () {}) : (i && i(a + r + "?d=" + j(c)), Promise.resolve());
    },
    sendEvents: function sendEvents(n, t, r) {
      if (!e.httpRequest) return Promise.resolve();
      var o,
          i = e.httpAllowsPost();
      o = i ? [n] : x(2e3 - t.length, n);

      for (var u = [], s = 0; s < o.length; s++) {
        u.push(a.sendChunk(o[s], t, r, i));
      }

      return Promise.all(u);
    }
  };
  return a;
}

function Ce() {
  var e = {},
      n = 0,
      t = 0,
      r = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var o = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
          i = r[o];
      i ? i.count = i.count + 1 : r[o] = {
        count: 1,
        key: e.key,
        variation: e.variation,
        version: e.version,
        value: e.value,
        default: e.default
      }, (0 === n || e.creationDate < n) && (n = e.creationDate), e.creationDate > t && (t = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {},
        o = !0;

    for (var i in r) {
      var a = r[i],
          u = e[a.key];
      u || (u = {
        default: a.default,
        counters: []
      }, e[a.key] = u);
      var s = {
        value: a.value,
        count: a.count
      };
      void 0 !== a.variation && null !== a.variation && (s.variation = a.variation), a.version ? s.version = a.version : s.unknown = !0, u.counters.push(s), o = !1;
    }

    return o ? null : {
      startDate: n,
      endDate: t,
      features: e
    };
  }, e.clearSummary = function () {
    n = 0, t = 0, r = {};
  }, e;
}

function Fe(e) {
  var n = {},
      t = e.allAttributesPrivate,
      r = e.privateAttributeNames || [],
      o = {
    key: !0,
    custom: !0,
    anonymous: !0
  },
      i = {
    key: !0,
    secondary: !0,
    ip: !0,
    country: !0,
    email: !0,
    firstName: !0,
    lastName: !0,
    avatar: !0,
    name: !0,
    anonymous: !0,
    custom: !0
  };
  return n.filterUser = function (e) {
    if (!e) return null;

    var n = e.privateAttributeNames || [],
        a = function a(e, i) {
      return Object.keys(e).reduce(function (a, u) {
        var s = a;
        return i(u) && (function (e) {
          return !o[e] && (t || -1 !== n.indexOf(e) || -1 !== r.indexOf(e));
        }(u) ? s[1][u] = !0 : s[0][u] = e[u]), s;
      }, [{}, {}]);
    },
        u = a(e, function (e) {
      return i[e];
    }),
        s = u[0],
        c = u[1];

    if (e.custom) {
      var l = a(e.custom, function () {
        return !0;
      });
      s.custom = l[0], c = F({}, c, l[1]);
    }

    var f = Object.keys(c);
    return f.length && (f.sort(), s.privateAttrs = f), s;
  }, n;
}

function qe(e, n, t, r) {
  var o = {};

  function i() {
    var e = "",
        o = r.getUser();
    return o && (e = t || U(JSON.stringify(o))), "ld:" + n + ":" + e;
  }

  return o.loadFlags = function () {
    return e.get(i()).then(function (e) {
      if (null == e) return null;

      try {
        var n = JSON.parse(e);

        if (n) {
          var t = n.$schema;
          void 0 === t || t < 1 ? n = N(n) : delete n.$schema;
        }

        return n;
      } catch (e) {
        return o.clearFlags().then(function () {
          return null;
        });
      }
    });
  }, o.saveFlags = function (n) {
    var t = F({}, n, {
      $schema: 1
    });
    return e.set(i(), JSON.stringify(t));
  }, o.clearFlags = function () {
    return e.clear(i());
  }, o;
}

function _e(e, n, t, r) {
  var o,
      i = n.streamUrl,
      a = n.logger,
      u = {},
      s = P(i, "/eval/" + t),
      c = n.useReport,
      l = n.evaluationReasons,
      f = n.streamReconnectDelay,
      d = Ne(e, n),
      v = !1,
      g = null,
      p = null,
      m = null,
      h = null,
      y = null;

  function w(e) {
    v || (a.warn(ge(e, f)), v = !0), D(!1), E(), b(f);
  }

  function b(e) {
    p || (e ? p = setTimeout(k, e) : k());
  }

  function k() {
    var r;
    p = null;
    var u = "",
        f = {
      headers: d,
      readTimeoutMillis: 3e5
    };

    if (e.eventSourceFactory) {
      for (var v in null != h && (u = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, f.method = "REPORT", f.headers["Content-Type"] = "application/json", f.body = JSON.stringify(m)) : (r = P(i, "/ping/" + t), u = "") : r = s + "/" + j(JSON.stringify(m)), f.headers = Ae(f.headers, n), l && (u = u + (u ? "&" : "") + "withReasons=true"), r = r + (u ? "?" : "") + u, E(), a.info(ve(r)), o = new Date().getTime(), g = e.eventSourceFactory(r, f), y) {
        q(y, v) && g.addEventListener(v, y[v]);
      }

      g.onerror = w;
    }
  }

  function E() {
    g && (a.info("Closing stream connection"), g.close(), g = null);
  }

  function D(e) {
    o && r && r.recordStreamInit(o, !e, new Date().getTime() - o), o = null;
  }

  return u.connect = function (e, n, t) {
    m = e, h = n, y = {};

    var r = function r(e) {
      y[e] = function (n) {
        v = !1, D(!0), t[e] && t[e](n);
      };
    };

    for (var o in t || {}) {
      r(o);
    }

    b();
  }, u.disconnect = function () {
    clearTimeout(p), p = null, E();
  }, u.isConnected = function () {
    return !!(g && e.eventSourceIsActive && e.eventSourceIsActive(g));
  }, u;
}

function Ve(e, n, t) {
  var r = n.baseUrl,
      o = n.useReport,
      i = n.evaluationReasons,
      a = n.logger,
      u = {},
      c = {};

  function l(t, r) {
    if (!e.httpRequest) return new Promise(function (e, n) {
      n(new d(de()));
    });
    var o = r ? "REPORT" : "GET",
        i = Ne(e, n);
    r && (i["Content-Type"] = "application/json");
    var a = c[t];
    a || (a = function (e) {
      var n,
          t,
          r,
          o,
          i = {
        addPromise: function addPromise(i, a) {
          n = i, t && t(), t = a, i.then(function (t) {
            n === i && (r(t), e && e());
          }, function (t) {
            n === i && (o(t), e && e());
          });
        }
      };
      return i.resultPromise = new Promise(function (e, n) {
        r = e, o = n;
      }), i;
    }(function () {
      delete c[t];
    }), c[t] = a);
    var u = e.httpRequest(o, t, Ae(i, n), r),
        l = u.promise.then(function (e) {
      if (200 === e.status) {
        if (e.header("content-type") && "application/json" === e.header("content-type").substring(0, "application/json".length)) return JSON.parse(e.body);
        var n = ee(e.header("content-type") || "");
        return Promise.reject(new d(n));
      }

      return Promise.reject(function (e) {
        return 404 === e.status ? new s(oe()) : new d(ae(e.statusText || String(e.status)));
      }(e));
    }, function (e) {
      return Promise.reject(new d(te(e)));
    });
    return a.addPromise(l, function () {
      u.cancel && u.cancel();
    }), a.resultPromise;
  }

  return u.fetchJSON = function (e) {
    return l(P(r, e), null);
  }, u.fetchFlagSettings = function (e, n) {
    var u,
        s,
        c,
        f = "";
    return o ? (s = [r, "/sdk/evalx/", t, "/user"].join(""), c = JSON.stringify(e)) : (u = j(JSON.stringify(e)), s = [r, "/sdk/evalx/", t, "/users/", u].join("")), n && (f = "h=" + n), i && (f = f + (f ? "&" : "") + "withReasons=true"), s = s + (f ? "?" : "") + f, a.debug(we(s)), l(s, c);
  }, u;
}

function ze(e) {
  var n = {
    validateUser: function validateUser(n) {
      if (!n) return Promise.reject(new c(ue()));
      var t = R(n);
      return null !== t.key && void 0 !== t.key ? (t.key = t.key.toString(), Promise.resolve(t)) : t.anonymous ? e.get("ld:$anonUserId").then(function (n) {
        if (n) return t.key = n, t;
        var r = G();
        return t.key = r, function (n) {
          return e.set("ld:$anonUserId", n);
        }(r).then(function () {
          return t;
        });
      }) : Promise.reject(new c(se()));
    }
  };
  return n;
}

var Je = Object.freeze({
  __proto__: null,
  baseOptionDefs: je,
  validate: Te,
  getTags: Le
}).baseOptionDefs,
    Me = V.appendUrlPath,
    $e = function $e(e) {
  var n = {
    diagnosticId: G()
  };
  return e && (n.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), n;
};

function He(e, r, o, i, a) {
  var c,
      f,
      p,
      m = o && o.logger ? o.logger : a && a.logger && a.logger.default || Q("warn"),
      h = function (e) {
    var n = {},
        t = {};
    return n.on = function (e, n, r) {
      t[e] = t[e] || [], t[e] = t[e].concat({
        handler: n,
        context: r
      });
    }, n.off = function (e, n, r) {
      if (t[e]) for (var o = 0; o < t[e].length; o++) {
        t[e][o].handler === n && t[e][o].context === r && (t[e] = t[e].slice(0, o).concat(t[e].slice(o + 1)));
      }
    }, n.emit = function (e) {
      if (t[e]) for (var n = t[e].slice(0), r = 0; r < n.length; r++) {
        n[r].handler.apply(n[r].context, Array.prototype.slice.call(arguments, 1));
      }
    }, n.getEvents = function () {
      return Object.keys(t);
    }, n.getEventListenerCount = function (e) {
      return t[e] ? t[e].length : 0;
    }, n.maybeReportError = function (n) {
      n && (t.error ? this.emit("error", n) : (e || console).error(n.message));
    }, n;
  }(m),
      y = function (e) {
    var n = !1,
        t = !1,
        r = null,
        o = null,
        i = new Promise(function (n) {
      e.on("ready", function t() {
        e.off("ready", t), n();
      });
    }).catch(function () {});
    return {
      getInitializationPromise: function getInitializationPromise() {
        return o || (n ? Promise.resolve() : t ? Promise.reject(r) : o = new Promise(function (n, t) {
          e.on("initialized", function t() {
            e.off("initialized", t), n();
          }), e.on("failed", function n(r) {
            e.off("failed", n), t(r);
          });
        }));
      },
      getReadyPromise: function getReadyPromise() {
        return i;
      },
      signalSuccess: function signalSuccess() {
        n || t || (n = !0, e.emit("initialized"), e.emit("ready"));
      },
      signalFailure: function signalFailure(o) {
        n || t || (t = !0, r = o, e.emit("failed", o), e.emit("ready")), e.maybeReportError(o);
      }
    };
  }(h),
      w = Te(o, h, a, m),
      b = w.sendEvents,
      k = e,
      E = w.hash,
      D = function (e, n) {
    var t = {},
        r = !1,
        o = function o(e) {
      r || (r = !0, n.warn(ne(e)));
    };

    return t.isEnabled = function () {
      return !!e;
    }, t.get = function (n) {
      return new Promise(function (t) {
        e ? e.get(n).then(t).catch(function (e) {
          o(e), t(void 0);
        }) : t(void 0);
      });
    }, t.set = function (n, t) {
      return new Promise(function (r) {
        e ? e.set(n, t).then(function () {
          return r(!0);
        }).catch(function (e) {
          o(e), r(!1);
        }) : r(!1);
      });
    }, t.clear = function (n) {
      return new Promise(function (t) {
        e ? e.clear(n).then(function () {
          return t(!0);
        }).catch(function (e) {
          o(e), t(!1);
        }) : t(!1);
      });
    }, t;
  }(i.localStorage, m),
      S = xe(i, k, w),
      O = w.sendEvents && !w.diagnosticOptOut,
      U = O ? $e(k) : null,
      j = O ? function (e) {
    var n, t, r, o;

    function i(e) {
      n = e, t = 0, r = 0, o = [];
    }

    return i(e), {
      getProps: function getProps() {
        return {
          dataSinceDate: n,
          droppedEvents: t,
          eventsInLastBatch: r,
          streamInits: o
        };
      },
      setProps: function setProps(e) {
        n = e.dataSinceDate, t = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
      },
      incrementDroppedEvents: function incrementDroppedEvents() {
        t++;
      },
      setEventsInLastBatch: function setEventsInLastBatch(e) {
        r = e;
      },
      recordStreamInit: function recordStreamInit(e, n, t) {
        var r = {
          timestamp: e,
          failed: n,
          durationMillis: t
        };
        o.push(r);
      },
      reset: i
    };
  }(new Date().getTime()) : null,
      N = O ? function (e, t, r, o, i, a, u) {
    var s,
        c,
        l = !!e.diagnosticUseCombinedEvent,
        f = "ld:" + i + ":$diagnostics",
        d = Me(a.eventsUrl, "/events/diagnostic/" + i),
        v = a.diagnosticRecordingInterval,
        g = r,
        p = !!a.streaming,
        m = {};

    function h() {
      return {
        sdk: b(),
        configuration: (n = {
          customBaseURI: a.baseUrl !== Je.baseUrl.default,
          customStreamURI: a.streamUrl !== Je.streamUrl.default,
          customEventsURI: a.eventsUrl !== Je.eventsUrl.default,
          eventsCapacity: a.eventCapacity,
          eventsFlushIntervalMillis: a.flushInterval,
          reconnectTimeMillis: a.streamReconnectDelay,
          streamingDisabled: !p,
          allAttributesPrivate: !!a.allAttributesPrivate,
          inlineUsersInEvents: !!a.inlineUsersInEvents,
          diagnosticRecordingIntervalMillis: a.diagnosticRecordingInterval,
          usingSecureMode: !!a.hash,
          bootstrapMode: !!a.bootstrap,
          fetchGoalsDisabled: !a.fetchGoals,
          allowFrequentDuplicateEvents: !!a.allowFrequentDuplicateEvents,
          sendEventsOnlyForVariation: !!a.sendEventsOnlyForVariation,
          autoAliasingOptOut: !!a.autoAliasingOptOut
        }, n),
        platform: e.diagnosticPlatformData
      };
      var n;
    }

    function y(e) {
      a.logger && a.logger.debug(Ue.debugPostingDiagnosticEvent(e)), o.sendEvents(e, d, !0).then(function () {}).catch(function () {});
    }

    function w() {
      var e, r;
      y((e = new Date().getTime(), r = n({
        kind: l ? "diagnostic-combined" : "diagnostic",
        id: u,
        creationDate: e
      }, g.getProps()), l && (r = n(n({}, r), h())), g.reset(e), r)), c = setTimeout(w, v), s = new Date().getTime(), l && function () {
        if (t.isEnabled()) {
          var e = n({}, g.getProps());
          t.set(f, JSON.stringify(e));
        }
      }();
    }

    function b() {
      var t = n({}, e.diagnosticSdkData);
      return a.wrapperName && (t.wrapperName = a.wrapperName), a.wrapperVersion && (t.wrapperVersion = a.wrapperVersion), t;
    }

    return m.start = function () {
      l ? function (e) {
        if (!t.isEnabled()) return e(!1);
        t.get(f).then(function (n) {
          if (n) try {
            var t = JSON.parse(n);
            g.setProps(t), s = t.dataSinceDate;
          } catch (e) {}
          e(!0);
        }).catch(function () {
          e(!1);
        });
      }(function (e) {
        if (e) {
          var n = (s || 0) + v,
              t = new Date().getTime();
          t >= n ? w() : c = setTimeout(w, n - t);
        } else 0 === Math.floor(4 * Math.random()) ? w() : c = setTimeout(w, v);
      }) : (y(n({
        kind: "diagnostic-init",
        id: u,
        creationDate: g.getProps().dataSinceDate
      }, h())), c = setTimeout(w, v));
    }, m.stop = function () {
      c && clearTimeout(c);
    }, m.setStreaming = function (e) {
      p = e;
    }, m;
  }(i, D, j, S, k, w, U) : null,
      x = _e(i, w, k, j),
      C = w.eventProcessor || function (e, n, t) {
    var r,
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
        a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        s = {},
        c = a || xe(e, t, n),
        l = P(n.eventsUrl, "/events/bulk/" + t),
        f = Ce(),
        d = Fe(n),
        v = n.inlineUsersInEvents,
        p = n.samplingInterval,
        m = n.eventCapacity,
        h = n.flushInterval,
        y = n.logger,
        w = [],
        b = 0,
        k = !1,
        E = !1;

    function D() {
      return 0 === p || 0 === Math.floor(Math.random() * p);
    }

    function S(e) {
      return !!e.debugEventsUntilDate && e.debugEventsUntilDate > b && e.debugEventsUntilDate > new Date().getTime();
    }

    function O(e) {
      var n = F({}, e);
      return "alias" === e.kind || (v || "identify" === e.kind ? n.user = d.filterUser(e.user) : (n.userKey = e.user.key, delete n.user), "feature" === e.kind && (delete n.trackEvents, delete n.debugEventsUntilDate)), n;
    }

    function U(e) {
      w.length < m ? (w.push(e), E = !1) : (E || (E = !0, y.warn("Exceeded event queue capacity. Increase capacity to avoid dropping events.")), o && o.incrementDroppedEvents());
    }

    return s.enqueue = function (e) {
      if (!k) {
        var n = !1,
            t = !1;

        if (f.summarizeEvent(e), "feature" === e.kind ? D() && (n = !!e.trackEvents, t = S(e)) : n = D(), n && U(O(e)), t) {
          var r = F({}, e, {
            kind: "debug"
          });
          r.user = d.filterUser(r.user), delete r.trackEvents, delete r.debugEventsUntilDate, U(r);
        }
      }
    }, s.flush = function () {
      if (k) return Promise.resolve();
      var e = w,
          n = f.getSummary();
      return f.clearSummary(), n && (n.kind = "summary", e.push(n)), o && o.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (w = [], y.debug(Oe(e.length)), c.sendEvents(e, l).then(function (e) {
        e && (e.serverTime && (b = e.serverTime), g(e.status) || (k = !0), e.status >= 400 && T(function () {
          i.maybeReportError(new u(fe(e.status, "event posting", "some events were dropped")));
        }));
      }));
    }, s.start = function () {
      r = setTimeout(function e() {
        s.flush(), r = setTimeout(e, h);
      }, h);
    }, s.stop = function () {
      clearTimeout(r);
    }, s;
  }(i, w, k, j, h, S),
      V = Ve(i, w, k),
      z = {},
      J = {},
      M = w.streaming,
      $ = !1,
      H = !1,
      K = !0,
      B = w.stateProvider,
      G = function (e, n) {
    var t,
        r = {
      setUser: function setUser(e) {
        var r = t && R(t);
        (t = _(e)) && n && n(R(t), r);
      },
      getUser: function getUser() {
        return t ? R(t) : null;
      }
    };
    return r;
  }(0, function (e, n) {
    (function (e) {
      B || e && Y({
        kind: "identify",
        key: e.key,
        user: e,
        creationDate: new Date().getTime()
      });
    })(e), !w.autoAliasingOptOut && n && n.anonymous && e && !e.anonymous && ue(e, n);
  }),
      X = ze(D),
      W = D.isEnabled() ? new qe(D, k, E, G, m) : null;

  function Y(e) {
    if (k && !(B && B.enqueueEvent && B.enqueueEvent(e))) {
      if ("alias" !== e.kind) {
        if (!e.user) return void (K && (m.warn("Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript"), K = !1));
        K = !1;
      }

      !b || H || i.isDoNotTrack() || (m.debug(Se(e.kind)), C.enqueue(e));
    }
  }

  function Z(e, n, t, r) {
    var o = G.getUser(),
        i = new Date(),
        a = n ? n.value : null;

    if (!w.allowFrequentDuplicateEvents) {
      var u = JSON.stringify(a) + (o && o.key ? o.key : "") + e,
          s = z[u];
      if (s && i - s < 3e5) return;
      z[u] = i;
    }

    var c = {
      kind: "feature",
      key: e,
      user: o,
      value: a,
      variation: n ? n.variationIndex : null,
      default: t,
      creationDate: i.getTime()
    };
    o && o.anonymous && (c.contextKind = oe(o));
    var l = J[e];
    l && (c.version = l.flagVersion ? l.flagVersion : l.version, c.trackEvents = l.trackEvents, c.debugEventsUntilDate = l.debugEventsUntilDate), (r || l && l.trackReason) && n && (c.reason = n.reason), Y(c);
  }

  function ee(e, n, t, r) {
    var o;

    if (J && q(J, e) && J[e] && !J[e].deleted) {
      var i = J[e];
      o = te(i), null !== i.value && void 0 !== i.value || (o.value = n);
    } else o = {
      value: n,
      variationIndex: null,
      reason: {
        kind: "ERROR",
        errorKind: "FLAG_NOT_FOUND"
      }
    };

    return t && Z(e, o, n, r), o;
  }

  function te(e) {
    return {
      value: e.value,
      variationIndex: void 0 === e.variation ? null : e.variation,
      reason: e.reason || null
    };
  }

  function oe(e) {
    return e.anonymous ? "anonymousUser" : "user";
  }

  function ue(e, n) {
    B || e && n && Y({
      kind: "alias",
      key: e.key,
      contextKind: oe(e),
      previousKey: n.key,
      previousContextKind: oe(n),
      creationDate: new Date().getTime()
    });
  }

  function se() {
    if (f = !0, G.getUser()) {
      var e = function e(_e2) {
        try {
          return JSON.parse(_e2);
        } catch (e) {
          return void h.maybeReportError(new v("Invalid data received from LaunchDarkly; connection may have been interrupted"));
        }
      };

      x.connect(G.getUser(), E, {
        ping: function ping() {
          m.debug("received ping message from stream");
          var e = G.getUser();
          V.fetchFlagSettings(e, E).then(function (n) {
            I(e, G.getUser()) && de(n || {});
          }).catch(function (e) {
            h.maybeReportError(new d(ae(e)));
          });
        },
        put: function put(n) {
          var t = e(n.data);
          t && (m.debug("received streaming update for all flags"), de(t));
        },
        patch: function patch(n) {
          var t = e(n.data);

          if (t) {
            var r = J[t.key];

            if (!r || !r.version || !t.version || r.version < t.version) {
              m.debug(be(t.key));
              var o = {},
                  i = F({}, t);
              delete i.key, J[t.key] = i;
              var a = te(i);
              o[t.key] = r ? {
                previous: r.value,
                current: a
              } : {
                current: a
              }, ve(o);
            } else m.debug(ke(t.key));
          }
        },
        delete: function _delete(n) {
          var t = e(n.data);
          if (t) if (!J[t.key] || J[t.key].version < t.version) {
            m.debug(Ee(t.key));
            var r = {};
            J[t.key] && !J[t.key].deleted && (r[t.key] = {
              previous: J[t.key].value
            }), J[t.key] = {
              version: t.version,
              deleted: !0
            }, ve(r);
          } else m.debug(De(t.key));
        }
      });
    }
  }

  function le() {
    f && (x.disconnect(), f = !1);
  }

  function de(e) {
    var t = {};
    if (!e) return Promise.resolve();

    for (var r in J) {
      q(J, r) && J[r] && (e[r] && !I(e[r].value, J[r].value) ? t[r] = {
        previous: J[r].value,
        current: te(e[r])
      } : e[r] && !e[r].deleted || (t[r] = {
        previous: J[r].value
      }));
    }

    for (var o in e) {
      q(e, o) && e[o] && (!J[o] || J[o].deleted) && (t[o] = {
        current: te(e[o])
      });
    }

    return J = n({}, e), ve(t).catch(function () {});
  }

  function ve(e) {
    var n = Object.keys(e);

    if (n.length > 0) {
      var t = {};
      n.forEach(function (n) {
        var r = e[n].current,
            o = r ? r.value : void 0,
            i = e[n].previous;
        h.emit("change:" + n, o, i), t[n] = r ? {
          current: o,
          previous: i
        } : {
          previous: i
        };
      }), h.emit("change", t), h.emit("internal-change", J), w.sendEventsOnlyForVariation || B || n.forEach(function (n) {
        Z(n, e[n].current);
      });
    }

    return c && W ? W.saveFlags(J) : Promise.resolve();
  }

  function ge() {
    var e = M || p && void 0 === M;
    e && !f ? se() : !e && f && le(), N && N.setStreaming(e);
  }

  function pe(e) {
    return "change" === e || "change:" === e.substr(0, "change".length + 1);
  }

  if ("string" == typeof w.bootstrap && "LOCALSTORAGE" === w.bootstrap.toUpperCase() && (W ? c = !0 : m.warn(ne())), "object" === t(w.bootstrap) && (J = function (e) {
    var n = Object.keys(e),
        t = e.$flagsState;
    !t && n.length && m.warn(ce()), !1 === e.$valid && m.warn("LaunchDarkly bootstrap data is not available because the back end could not read the flags.");
    var r = {};
    return n.forEach(function (n) {
      if ("$flagsState" !== n && "$valid" !== n) {
        var o = {
          value: e[n]
        };
        t && t[n] ? o = F(o, t[n]) : o.version = 0, r[n] = o;
      }
    }), r;
  }(w.bootstrap)), B) {
    var me = B.getInitialState();
    me ? he(me) : B.on("init", he), B.on("update", function (e) {
      e.user && G.setUser(e.user), e.flags && de(e.flags);
    });
  } else (e ? X.validateUser(r).then(function (e) {
    return G.setUser(e), "object" === t(w.bootstrap) ? ye() : c ? W.loadFlags().then(function (e) {
      return null == e ? (J = {}, V.fetchFlagSettings(G.getUser(), E).then(function (e) {
        return de(e || {});
      }).then(ye).catch(function (e) {
        we(new d(ae(e)));
      })) : (J = e, T(ye), V.fetchFlagSettings(G.getUser(), E).then(function (e) {
        return de(e);
      }).catch(function (e) {
        return h.maybeReportError(e);
      }));
    }) : V.fetchFlagSettings(G.getUser(), E).then(function (e) {
      J = e || {}, ye();
    }).catch(function (e) {
      J = {}, we(e);
    });
  }) : Promise.reject(new s(ie()))).catch(we);

  function he(e) {
    k = e.environment, G.setUser(e.user), J = n({}, e.flags), T(ye);
  }

  function ye() {
    m.info("LaunchDarkly client initialized"), $ = !0, ge(), y.signalSuccess();
  }

  function we(e) {
    y.signalFailure(e);
  }

  return {
    client: {
      waitForInitialization: function waitForInitialization() {
        return y.getInitializationPromise();
      },
      waitUntilReady: function waitUntilReady() {
        return y.getReadyPromise();
      },
      identify: function identify(e, n, t) {
        return H ? L(Promise.resolve({}), t) : B ? (m.warn("identify() has no effect here; it must be called on the main client instance"), L(Promise.resolve(A(J)), t)) : L((c && W ? W.clearFlags() : Promise.resolve()).then(function () {
          return X.validateUser(e);
        }).then(function (e) {
          return V.fetchFlagSettings(e, n).then(function (t) {
            var r = A(t);
            return G.setUser(e), E = n, t ? de(t).then(function () {
              return r;
            }) : r;
          });
        }).then(function (e) {
          return f && se(), e;
        }).catch(function (e) {
          return h.maybeReportError(e), Promise.reject(e);
        }), t);
      },
      getUser: function getUser() {
        return G.getUser();
      },
      variation: function variation(e, n) {
        return ee(e, n, !0, !1).value;
      },
      variationDetail: function variationDetail(e, n) {
        return ee(e, n, !0, !0);
      },
      track: function track(e, n, t) {
        if ("string" == typeof e) {
          i.customEventFilter && !i.customEventFilter(e) && m.warn(re(e));
          var r = G.getUser(),
              o = {
            kind: "custom",
            key: e,
            user: r,
            url: i.getCurrentUrl(),
            creationDate: new Date().getTime()
          };
          r && r.anonymous && (o.contextKind = oe(r)), null != n && (o.data = n), null != t && (o.metricValue = t), Y(o);
        } else h.maybeReportError(new l(re(e)));
      },
      alias: ue,
      on: function on(e, n, t) {
        pe(e) ? (p = !0, $ && ge(), h.on(e, n, t)) : h.on.apply(h, arguments);
      },
      off: function off(e) {
        if (h.off.apply(h, arguments), pe(e)) {
          var n = !1;
          h.getEvents().forEach(function (e) {
            pe(e) && h.getEventListenerCount(e) > 0 && (n = !0);
          }), n || (p = !1, f && void 0 === M && le());
        }
      },
      setStreaming: function setStreaming(e) {
        var n = null === e ? void 0 : e;
        n !== M && (M = n, ge());
      },
      flush: function flush(e) {
        return L(b ? C.flush() : Promise.resolve(), e);
      },
      allFlags: function allFlags() {
        var e = {};
        if (!J) return e;

        for (var n in J) {
          q(J, n) && (e[n] = ee(n, null, !w.sendEventsOnlyForVariation).value);
        }

        return e;
      },
      close: function close(e) {
        if (H) return L(Promise.resolve(), e);

        var n = function n() {
          H = !0, J = {};
        };

        return L(Promise.resolve().then(function () {
          if (le(), N && N.stop(), b) return C.stop(), C.flush();
        }).then(n).catch(n), e);
      }
    },
    options: w,
    emitter: h,
    ident: G,
    logger: m,
    requestor: V,
    start: function start() {
      b && (N && N.start(), C.start());
    },
    enqueueEvent: Y,
    getFlagsInternal: function getFlagsInternal() {
      return J;
    },
    getEnvironmentId: function getEnvironmentId() {
      return k;
    },
    internalChangeEventName: "internal-change"
  };
}

function Ke(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function Be(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? Ke(Object(t), !0).forEach(function (n) {
      Ge(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ke(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }

  return e;
}

function Ge(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}

var Xe = Object.freeze({
  __proto__: null,
  commonBasicLogger: W,
  createConsoleLogger: Q,
  errors: p,
  initialize: He,
  messages: Ue,
  utils: V,
  version: "3.6.0"
}).commonBasicLogger;

var We = function We(e) {
  return Xe(Be({
    destination: console.log
  }, e));
};

var Qe = {
  promise: Promise.resolve({
    status: 200,
    header: function header() {
      return null;
    },
    body: null
  })
};

function Ye(e, n, t, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;

    if (e) {
      var n = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (n) return parseInt(n[2], 10) < 73;
    }

    return !0;
  }()) return Qe;
  var i = new window.XMLHttpRequest();

  for (var a in i.open(e, n, !o), t || {}) {
    Object.prototype.hasOwnProperty.call(t, a) && i.setRequestHeader(a, t[a]);
  }

  if (o) return i.send(r), Qe;
  var u,
      s = new Promise(function (e, n) {
    i.addEventListener("load", function () {
      u || e({
        status: i.status,
        header: function header(e) {
          return i.getResponseHeader(e);
        },
        body: i.responseText
      });
    }), i.addEventListener("error", function () {
      u || n(new Error());
    }), i.send(r);
  });
  return {
    promise: s,
    cancel: function cancel() {
      u = !0, i.abort();
    }
  };
}

function Ze(e) {
  var n,
      t = {
    synchronousFlush: !1
  };

  if (window.XMLHttpRequest) {
    var r = e && e.disableSyncEventPost;

    t.httpRequest = function (e, n, o, i) {
      var a = t.synchronousFlush & !r;
      return t.synchronousFlush = !1, Ye(e, n, o, i, a);
    };
  }

  t.httpAllowsPost = function () {
    return void 0 === n && (n = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), n;
  }, t.httpFallbackPing = function (e) {
    new window.Image().src = e;
  };
  var o,
      i = e && e.eventUrlTransformer;
  t.getCurrentUrl = function () {
    return i ? i(window.location.href) : window.location.href;
  }, t.isDoNotTrack = function () {
    var e;
    return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
  };

  try {
    window.localStorage && (t.localStorage = {
      get: function get(e) {
        return new Promise(function (n) {
          n(window.localStorage.getItem(e));
        });
      },
      set: function set(e, n) {
        return new Promise(function (t) {
          window.localStorage.setItem(e, n), t();
        });
      },
      clear: function clear(e) {
        return new Promise(function (n) {
          window.localStorage.removeItem(e), n();
        });
      }
    });
  } catch (e) {
    t.localStorage = null;
  }

  if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (t.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (t.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
    var a = 3e5;
    t.eventSourceFactory = function (e, n) {
      var t = Be(Be({}, {
        heartbeatTimeout: a,
        silentTimeout: a,
        skipDefaultHeaders: !0
      }), n);
      return new o(e, t);
    }, t.eventSourceIsActive = function (e) {
      return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
    };
  }

  return t.userAgent = "JSClient", t.version = "2.22.1", t.diagnosticSdkData = {
    name: "js-client-sdk",
    version: "2.22.1"
  }, t.diagnosticPlatformData = {
    name: "JS"
  }, t.diagnosticUseCombinedEvent = !0, t;
}

var en = /[|\\{}()[\]^$+*?.]/g,
    nn = function nn(e) {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(en, "\\$&");
};

function tn(e, n, t, r) {
  var o,
      i,
      a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? n : n.replace(r, "")).replace(t, "");

  switch (e.kind) {
    case "exact":
      i = n, o = new RegExp("^" + nn(e.url) + "/?$");
      break;

    case "canonical":
      i = a, o = new RegExp("^" + nn(e.url) + "/?$");
      break;

    case "substring":
      i = a, o = new RegExp(".*" + nn(e.substring) + ".*$");
      break;

    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;

    default:
      return !1;
  }

  return o.test(i);
}

function rn(e, n) {
  for (var t = {}, r = null, o = [], i = 0; i < e.length; i++) {
    for (var a = e[i], u = a.urls || [], s = 0; s < u.length; s++) {
      if (tn(u[s], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? n("pageview", a) : (o.push(a), n("click_pageview", a));
        break;
      }
    }
  }

  return o.length > 0 && (r = function r(e) {
    for (var t = function (e, n) {
      for (var t = [], r = 0; r < n.length; r++) {
        for (var o = e.target, i = n[r], a = i.selector, u = document.querySelectorAll(a); o && u.length > 0;) {
          for (var s = 0; s < u.length; s++) {
            o === u[s] && t.push(i);
          }

          o = o.parentNode;
        }
      }

      return t;
    }(e, o), r = 0; r < t.length; r++) {
      n("click", t[r]);
    }
  }, document.addEventListener("click", r)), t.dispose = function () {
    document.removeEventListener("click", r);
  }, t;
}

function on(e, n) {
  var t, r;

  function o() {
    r && r.dispose(), t && t.length && (r = rn(t, i));
  }

  function i(n, t) {
    var r = e.ident.getUser(),
        o = {
      kind: n,
      key: t.key,
      data: null,
      url: window.location.href,
      user: r,
      creationDate: new Date().getTime()
    };
    return r && r.anonymous && (o.contextKind = "anonymousUser"), "click" === n && (o.selector = t.selector), e.enqueueEvent(o);
  }

  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = rn(t = e, i), function (e, n) {
      var t,
          r = window.location.href;

      function o() {
        (t = window.location.href) !== r && (r = t, n());
      }

      !function e(n, t) {
        n(), setTimeout(function () {
          e(n, t);
        }, t);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(300, o)), n();
  }).catch(function (t) {
    e.emitter.maybeReportError(new p.LDUnexpectedResponseError((t && t.message, t.message))), n();
  }), {};
}

var an = {
  fetchGoals: {
    default: !0
  },
  hash: {
    type: "string"
  },
  eventProcessor: {
    type: "object"
  },
  eventUrlTransformer: {
    type: "function"
  },
  disableSyncEventPost: {
    default: !1
  }
};

function un(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = Ze(t),
      o = He(e, n, t, r, an),
      i = o.client,
      a = o.options,
      u = o.emitter,
      s = new Promise(function (e) {
    var n = u.on("goalsReady", function () {
      u.off("goalsReady", n), e();
    });
  });
  i.waitUntilGoalsReady = function () {
    return s;
  }, a.fetchGoals ? on(o, function () {
    return u.emit("goalsReady");
  }) : u.emit("goalsReady"), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();

  var c = function c() {
    r.synchronousFlush = !0, i.flush().catch(function () {}), r.synchronousFlush = !1;
  };

  return window.addEventListener("beforeunload", c), window.addEventListener("unload", c), i;
}

var sn = We,
    cn = Q,
    ln = "2.22.1";
var fn = {
  initialize: function initialize(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(Ue.deprecated("default export", "named LDClient export")), un(e, n, t);
  },
  version: "2.22.1"
};
export default fn;
export { sn as basicLogger, cn as createConsoleLogger, un as initialize, ln as version };